import { combineReducers } from 'redux'
import tabs from './tabs'
import buttons from './buttons'
import collapsed from './collapsed'
import memberDetail from './member-detail'
const rootReducer = combineReducers({
    tabs,
    buttons,
    collapsed,
    memberDetail,
})
export default rootReducer